export default __webpack_public_path__ + "2890fffe8b708cf8f1f994c57a3d0846.svg";